import React from 'react'
import classNames from 'classnames'

interface VisitStatusLabelProps {
  className?: string
  isRunActive?: boolean
  status?: string
}

function VisitStatusLabel({
  className,
  isRunActive,
  status,
}: VisitStatusLabelProps) {
  let label: string

  if (!status && isRunActive) {
    label = 'Pending'
  } else if (!status || status === 'skipped') {
    label = 'Skipped'
  } else if (status === 'in-progress') {
    label = 'In Progress'
  } else if (status === 'completed') {
    label = 'Completed'
  } else {
    label = status
  }

  return (
    <span
      className={classNames(
        {
          'text-color-neutral': !status && isRunActive,
          'text-color-neutral-faded':
            status === 'skipped' || (!status && !isRunActive),
          'text-color-strong': status === 'in-progress',
        },
        className,
      )}
    >
      {label}
    </span>
  )
}

export {VisitStatusLabel}
